/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { mdiCamera } from '@mdi/js';
import Icon from '@mdi/react';

import { FormProps } from './types';
import { useHTMLCamera } from '../../../components/HTMLCamera';

function Photos({ question }: FormProps, ref: any) {
  const { takePhoto } = useHTMLCamera();

  if (question.type !== 'photos') return null;

  const handleClick = () => {
    takePhoto(() => {
      console.log('done');
    });
  };

  return (
    <>
      <div className="dynamic-form-label">{question.label}</div>
      <div>
        <button type="button" className="dynamic-form-input dynamic-form-photo-button width-auto" onClick={handleClick}>
          <Icon path={mdiCamera} size={1} />
          Take Photo
        </button>
      </div>
    </>
  );
}

export default React.forwardRef(Photos);
